<div class="border-0 scroll-container" ref="manage_workflow">
  <NavigationBackButton />

  <div>
    <div class="d-flex ms-3 gap-2 mb-3 mt-3 overview-entity-header">
      <i class="bi bi-briefcase-fill fs-4 flex-shrink-0 overview-briefcase-green"></i>
      <p class="text-dark mb-0 fs-5 fw-700 d-flex align-items-center pointer overview-entity-title">
        {{ entity_type_name }}
      </p>

    </div>

    <!-- MASTER TABS -->
    <div class="row row-cols-2 g-2 mb-3 mb-md-4 px-2">
      <div class="col">
        <div
          class="card shadow-sm border-0 h-100 text-center cursor-pointer overview-master-tab"
          :class="active_master_tab === 'profile' ? 'bg-primary-dark text-white' : 'bg-primary-blue bg-light text-white'"
          @click="select_master_tab('profile')"
        >
          <div class="card-body overview-master-tab-body">
            <i class="bi bi-journal-text overview-master-tab-icon"
               :class="active_master_tab === 'profile' ? 'text-white' : 'text-white'"
            ></i>
            <p class="mb-0 overview-master-tab-title fw-semibold">Job Application Information</p>
            <small class="overview-master-tab-copy" :class="active_master_tab === 'profile' ? 'text-white' : 'text-white'">Forms & Sections</small>
          </div>
        </div>
      </div>

      <div class="col">
        <div
          class="card shadow-sm border-0 h-100 text-center cursor-pointer overview-master-tab"
          :class="active_master_tab === 'documents' ? 'bg-primary-dark text-white' : 'bg-primary-blue bg-light text-white'"
          @click="select_master_tab('documents')"
        >
          <div class="card-body overview-master-tab-body">
            <i class="bi bi-file-earmark-text overview-master-tab-icon"
               :class="active_master_tab === 'documents' ? 'text-white' : 'text-white'"
            ></i>
            <p class="mb-0 overview-master-tab-title fw-semibold">Uploaded Documents</p>
            <small class="overview-master-tab-copy" :class="active_master_tab === 'documents' ? 'text-white' : 'text-white'">Your CVs & Files</small>
          </div>
        </div>
      </div>
    </div>

    <p v-if="!is_advert_locked" class="ms-3 text-x text-dark fw-bold d-none d-md-flex align-items-center">
      <i class="bi bi-exclamation-circle me-1"></i>
      If you wish to make any changes or correct the information in your Job Application Form, you can do so below.
    </p>
    <p v-if="!is_advert_locked && show_info_text" class="ms-3 text-xxs text-dark fw-bold d-flex d-md-none align-items-center">
      <i class="bi bi-exclamation-circle me-1"></i>
      If you wish to make any changes or correct the information in your Job Application Form, you can do so below.
    </p>
    <p v-if="is_advert_locked" class="ms-3 text-x text-danger fw-700">
      <i class="bi bi-lock-fill me-2"></i>
      Job advert closed. You cannot edit or submit this form.
    </p>

    <!-- MAIN LAYOUT -->
    <div class="overview-application-container">

      <!-- CONTENT -->
      <div class="w-100 overview-dropdown-column rounded-lg">

        <div class="overview-accordion-container mb-3">

          <div v-if="active_master_tab === 'documents'" class="documents-tab-panel overview-tab-scroll-panel">
            <EntityDocuments />
          </div>

          <div v-else-if="active_master_tab === 'compliance'">
            <OnboardingComplianceComponent :entity_profile_id="entity_profile_id" />
          </div>

          <div v-else-if="active_master_tab === 'profile'" class="job-application-info-panel overview-tab-scroll-panel">
            <div class="overview-profile-host" :class="{ 'is-advert-locked': is_advert_locked }">
              <div v-if="is_advert_locked" class="alert alert-warning text-xxs mb-2">
                {{ advert_lock_message }}
              </div>
              <ProfileInfo
                form_source="entity"
                :application_id="application_id"
                :entity_profile_id="entity_profile_id"
                :entity_application_form_id="application_form_id"
                :entity_form_main_section_ids="dynamic_form_tabs.map((tab) => dropdown_forms_id(tab.id)).filter(Boolean)"
              />
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- Edit Entity Modal -->
 <teleport to="body">
  <div class="modal fade" id="edit_entity_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs">Edit Entity Name</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                  @click="show_edit_entity_modal = false"></button>
        </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label class="form-label text-xxs">Entity Name:</label>
              <input
                type="text"
                v-model.trim="current_edit_entity.name"
                :class="{'is-invalid': entity_name_error}"
                @input="entity_name_error = false"
                class="form-control text-xxs rounded-3 p-2 shadow-sm"
                placeholder="Enter entity name"
                @keyup.enter="save_edited_entity"
              />
              <div v-if="entity_name_error" class="invalid-feedback small">
                Please enter an entity name
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              @click="save_edited_entity"
              :disabled="!current_edit_entity.name?.trim()"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>

      </div>
    </div>
  </div>
</teleport>
